<template>
    <div id="transactionCompletePage" class="container bg-white px-0 py-5">
        <div class="d-flex flex-column align-items-center text-center p-2">
            <img
                alt=""
                src="/img/hcpay/transaction-complete-icon-2.svg"
                class="transactionCompleteIcon img-responsive"
            />
            <span
                class="font-md font-weight-bold text-gray-dk text-capitalize my-3"
                >Transaction Complete!</span
            >
            <span class="font-sm text-secondary"
                >Your purchase will be processed by the merchant.</span
            >
            <span class="font-lg font-weight-bold text-gray-dk mt-4 mb-2"
                >₱ {{ amount }}</span
            >
            <span class="font-xs text-secondary my-2"
                >has been successfully paid to</span
            >
            <span
                v-if="!$root.$data.transaction.partnerId"
                class="font-sm font-weight-bold text-gray-dk text-capitalize mb-3"
            >
                {{ $root.$data.transaction.merchantName }}
            </span>
            <span
                v-else
                class="font-sm font-weight-bold text-gray-dk text-capitalize mb-3"
            >
                {{ $root.$data.transaction.partnerName }} -
                {{ $root.$data.transaction.merchantName }}
            </span>
            <span class="font-xs text-secondary">from your</span>
            <span class="font-sm font-weight-bold text-gray-dk mt-2 mb-3">{{
                $root.$data.paymentOptionLabel ? 
                $root.$data.paymentOptionLabel : 
                newTransactionDetails.paymentOptionLabel
            }}</span>
        </div>
        <hr class="customDivider" />
        <div class="px-4 mt-4 mb-5">
            <payment-summary class="mx-auto" :dropdown="true" />
        </div>
        <div class="d-flex flex-column justify-content-center text-center px-5">
            <span
                class="font-xs font-weight-bold text-gray-dk text-capitalize mb-2"
                >Reference No.
                {{ $root.$data.transaction.referenceNumber }}</span
            >
            <span class="font-xs font-weight-bold text-secondary mb-4">{{
                newTransactionDetails.transUpdateTime | moment
            }}</span>
            <div v-if="!this.$root.$data.transaction.partnerId" class="px-5">
                <button
                    type="button"
                    id="transactionCompleteBackToStore"
                    @click="backToStore"
                    class="btn btn-success btn-block rounded-lg py-2 mb-3"
                >
                    Back to Store
                </button>
            </div>
            <div v-else class="px-5">
                <button
                    type="button"
                    id="transactionCompleteBackToStore"
                    @click="backToStore"
                    class="btn btn-success btn-block rounded-lg py-2 mb-3"
                >
                    Back to Merchant
                </button>
            </div>

            <button
                type="button"
                id="transactionCompleteShareFeedback"
                class="btn btn-link-success font-weight-bold font-sm text-green text-capitalize"
                @click="openQualtrics()"
                v-if="qualtricsEnabled"
            >
                Share Feedback
            </button>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    data() {
        const qualtricsBtnEl = document.getElementById("QSIFeedbackButton-btn");
        return {
            qualtricsEnabled: !!qualtricsBtnEl,
            newTransactionDetails: {},
        };
    },
    async created() {
        let g4params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type:
                this.$root.$data.transaction.referenceNumber.substring(0, 2),
            transaction_reference: this.$root.$data.transaction.referenceNumber,
        };
        this.$root.triggerG4Event("payment_success_page", g4params);
        this.$root.$data.complete = true;
        this.$root.$data.previousView = "transaction-complete";
        const { data } = await axios.post(
            "hcpay/getNewTransactionDetails",
            this.$root.$data
        );
        this.newTransactionDetails = data;
        if (data) {
            this.newTransactionDetails = data;
        } else {
            this.newTransactionDetails = $root.$data.transaction;
        }
    },
    computed: {
        amount() {
            let val = (this.$root.$data.transaction.amount / 1)
                .toFixed(2)
                .replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    methods: {
        backToStore() {
            if (
                !this.$root.transaction.successURL ||
                this.$root.transaction.successURL == "undefined"
            ) {
                window.location.href = this.$root.transaction.callBackURL;
            } else {
                window.location.href = this.$root.transaction.successURL;
            }
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        openQualtrics() {
            const qualtricsBtnEl = document.getElementById(
                "QSIFeedbackButton-btn"
            );
            if (!qualtricsBtnEl) {
                return;
            }
            qualtricsBtnEl.click();
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format("DD MMM YYYY | hh:mm a").toUpperCase();
        },
    },
};
</script>
<style scoped>
.transactionCompleteIcon {
    height: auto;
    width: 7rem;
}
</style>
